import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {BaseAPIService} from '@app/core/service/base-api.service';
import {environment} from '@env/environment';
import {DefaultSchemaListItem} from '@app/views/admin/application-settings/models/data-schema-name.model';

@Injectable({
    providedIn: 'root'
})
export class SchemaListService extends BaseAPIService {

    public errorMessage = new EventEmitter <string> ();
    private readonly GET_SCHEMA_LIST_ERROR_MESSAGE = 'Could not load Data Schema List.';

    public getDefaultIntegrations(errorMessage: string = this.GET_SCHEMA_LIST_ERROR_MESSAGE): Observable<DefaultSchemaListItem[]> {
        const url = `${environment.datahubBaseURI}/api/v2/applications/integrations/sftp/default/scheme`;
        return this.get(url)
            .pipe(catchError(error => this.handleError(error, errorMessage)));
    }

    public transformDataSchemaName(schemaName: string): string {
        const firstUnderscoreIndex = schemaName.indexOf('_');
        const lastUnderscoreIndex = schemaName.lastIndexOf('_');
        return schemaName.substring(firstUnderscoreIndex + 1, lastUnderscoreIndex);
    }
}
